var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.188 0 0 6 0 6C0 6 4.188 12 11 12C17.812 12 22 6 22 6C22 6 17.812 0 11 0ZM11 10C7.057 10 4.074 7.516 2.621 6C3.661 4.915 5.483 3.343 7.875 2.531C7.3117 3.23091 7.00314 4.10157 7 5C7 6.06087 7.42143 7.07828 8.17157 7.82843C8.92172 8.57857 9.93913 9 11 9C12.0609 9 13.0783 8.57857 13.8284 7.82843C14.5786 7.07828 15 6.06087 15 5C14.9969 4.10157 14.6883 3.23091 14.125 2.531C16.518 3.343 18.341 4.916 19.379 6C17.924 7.518 14.942 10 11 10V10Z",
    fill: "#5A5C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeicon);
export default __webpack_public_path__ + "static/media/eyeicon.b5fb95f141dba11466c85776bbc68ca7.svg";
export { ForwardRef as ReactComponent };